var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visible)?_c('div',{class:['discount-badge', _vm.badgeTypeClass, { 'animated': _vm.animate }]},[_c('span',{staticClass:"badge-icon"},[_vm._v(_vm._s(_vm.badgeIcon))]),_c('span',{staticClass:"badge-text"},[_vm._v(_vm._s(_vm.badgeText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }